import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./CreateFolderModal.module.scss";

// import Container from "components/Container/Container";
import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import Radio from "components/Radio/Radio";
import FormElement from "components/FormElement/FormElement";
import DateInput from "components/DateInput/DateInput";

// import Input from "components/Input/Input";
import Select from "components/Select/Select";
import SearchInput from "components/SearchInput/SearchInput";
import Checkbox from "components/Checkbox/Checkbox";
import { loadFoldersAction, loadSitesAction, loadDeptAction, createFolderAction, updateFolderAction } from "store/actions/Actions";

/**
 *
 * @param {Function} setShowModal - toggles the modal
 */
const CreateFolderModal = props => {
    const [state, setState] = useState({
        folderName: "",
        parentFolderId: 0,
        parentFolder: "",
        docFolders: [],
        permissionLevel: true,
        siteId: "",
        site: "",
        departmentId : "",
        department : "",
        expiration_date: "",
        description: "",
        admins_only: false,
        label: 'Folder ',
        requires_attest: false
    });

    const [docFolders, setDocFolders] = useState(state.docFolders);
    const [parentFolderId, setParentFolderId] = useState(state.parentFolderId);
    const [parentFolder, setParentFolder] = useState(state.parentFolder);
    const [siteId, setSiteId] = useState(state.siteId);
    const [site, setSite] = useState(state.site);
    const [departmentId, setDepartmentId] = useState(state.departmentId);
    const [department, setDepartment] = useState(state.department);

    const [stateErrors, setStateErrors] = useState({});

    // Load folder stucture
    const { loadFoldersAction, folders, editFolder, loadSitesAction, loadDeptAction } = props;
    useEffect(() => {
        loadFoldersAction()
    }, [loadFoldersAction]);

    useEffect(() => {
       if (editFolder){

            if(editFolder.type === 'file'){
                setState((s) => ({
                    ...s,
                    label: 'File '
                }));
            }
           
           setState((s) => ({
            ...s,
            folderName: editFolder.folder_name,
            permissionLevel: editFolder.permission_site ? false : true
        }));
        setParentFolderId(editFolder.parent_folder);
        if (editFolder.permission_site){
            loadSitesAction();
            setSiteId(editFolder.permission_site);
        }
        if (editFolder.permission_department){
            loadDeptAction({site: parseInt(editFolder.permission_site)});
            setDepartmentId(editFolder.permission_department);
        }

        if (editFolder.admins_only){
            setState((s) => ({
                ...s,
                admins_only: editFolder.admins_only
            }));
        }

        if (editFolder.requires_attest){
            setState((s) => ({
                ...s,
                requires_attest: editFolder.requires_attest
            }));
        }
       }
    }, [editFolder, loadSitesAction, loadDeptAction]);

    const parentFolderProp = props.parentFolder;
    // Put folder structure in local state
    useEffect(() =>{
        setDocFolders(folders);
        if (parentFolderProp && parentFolderProp.id){
            setParentFolderId(parentFolderProp.id);
        }
    }, [folders, parentFolderProp]);

    const { sites, departments } = props;

    useEffect(() =>{
        if (folders){
            let selected = folders.filter(f =>
                f.id === parentFolderId
            )
        
            if (selected && selected.length === 1){
                setParentFolder(selected[0].folder_name)
            }
        }
    }, [parentFolderId, folders]);

    useEffect(() =>{
        if (sites){
            let selected = sites.filter(f =>
                f.id === siteId
            )
        
            if (selected && selected.length === 1){
                setSite(selected[0].name)
            }
        }
    }, [siteId, sites]);


    useEffect(() =>{
        if (departments){
            let selected = departments.filter(f =>
                f.id === departmentId
            )
        
            if (selected && selected.length === 1){
                setDepartment(selected[0].name)
            }
        }
    }, [departmentId, departments]);

    const statusFolderDropdown = React.createRef();
    const siteDropdown = React.createRef();
    const departmentDropdown = React.createRef();

    const handleChangeRadio = inputName => e => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value === "true" ? true : false,
        }));
        if (inputName === "permissionLevel"){
            props.loadSitesAction();
        }
    };

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const searchFolders = e => {
        setDocFolders(
            folders.filter(f =>
                f.folder_name.toUpperCase().includes(e.target.value.toUpperCase())
            )
        );
    };


    const handleAdminsOnly = (e) => {

        e.persist();
        setState((s) => ({
            ...s,
            admins_only: !state.admins_only
        }));
    }

    const handleRequiresAttest = (e) => {

        e.persist();
        setState((s) => ({
            ...s,
            requires_attest: !state.requires_attest
        }));
    }

    const createFolder = async (e) => {
        if (state.folderName === "") {
            setStateErrors({
                ...stateErrors,
                folderName: state.folderName === "" ? state.label + " name is required" : "",
            });
        } else {
            const { folderName } = state;
            let data = {
                folder_name: folderName,
                parent_folder: parentFolderId,
                permission_site: siteId,  
                permission_department:  departmentId,
                admins_only: state.admins_only,
                requires_attest: state.requires_attest,
                expiration_date: state.expiration_date,
            }

            if (editFolder){
                data.id = editFolder.id;
                await props.updateFolderAction(data);
            }else{
                await props.createFolderAction(data);
            }
            props.setShowModal(false);
        }
    };

    return (
        <Modal setShowModal={props.setShowModal} className={styles.modal}>
            <div className={styles["modal-header"]}>
                {!props.editFolder ?
                <h2 className={styles.heading}>Create Folder</h2> :
                <h2 className={styles.heading}>Edit {state.label}</h2>}
            </div>
            <div className={styles["modal-body"]}>
                <div className={styles["existing-folder"]}>
                    <label>
                        <b>{state.label} NAME</b>
                    </label>
                        <FormElement
                            errorMessage={stateErrors["folderName"] || ""}
                        >
                            <input
                                className={styles['folder-name']}
                                placeholder="Folder Name"
                                type="text"
                                value={state.folderName}
                                onChange={handleChange("folderName")}
                            >
                            </input>
                        </FormElement>
                    <label>
                        <b>PARENT FOLDER</b> (optional)
                    </label>
                    <Select
                        value={parentFolder}
                        menuClassName={styles["parent-folder-select"]}
                        dropdownToggleRef={statusFolderDropdown}
                        onClick={(e) => { if (e.target.type !=='text') { statusFolderDropdown.current.click(); setParentFolderId(e.target.value+"") }}}
                    >
                        <div className={styles["parent-folder"]}>
                            <SearchInput
                                className={styles["search-input"]}
                                onChange={searchFolders}
                            />
                            {docFolders && docFolders.map(f => (
                                <li
                                    value={f.id}
                                    key={f.id}
                                    className={`${styles.folder} ${
                                        styles[`depth-${f.level}`]
                                    }`}
                                >
                                    <i
                                        className={
                                            f.level === "0"
                                                ? "fas fa-folder"
                                                : "far fa-folder"
                                        }
                                    />
                                    {f.folder_name} 
                                </li>
                            ))}
                        </div>
                    </Select>
                    <label className={styles["permission-level-label"]}>
                        <b>PERMISSION LEVEL</b>
                    </label>
                    <div>
                        <Radio
                            checked={state.permissionLevel}
                            labelText="Entire Organization (default)"
                            onChange={handleChangeRadio("permissionLevel")}
                            value={true}
                        />
                        <div className={styles["site-dept"]}>
                            <Radio
                                labelClassName={styles["permission-level"]}
                                checked={!state.permissionLevel}
                                labelText={false}
                                onChange={ handleChangeRadio("permissionLevel") }
                                value={false}
                            />
                            <Select
                                disabled={Boolean(state.permissionLevel)}
                                placeholder="Select Site"
                                value={site}
                                dropdownToggleRef={siteDropdown}
                                onClick={ (e) => {siteDropdown.current.click();  setSiteId(e.target.value+""); props.loadDeptAction({site: e.target.value}); }}
                            >
                                {sites && sites.map(f => (
                                <li
                                    value={f.id}
                                    key={f.id}>
                                {f.name}</li>
                               ))}
                            </Select>
                            <Select
                                disabled={!site}
                                placeholder="Select Department"
                                dropdownToggleRef={departmentDropdown}
                                value={department}
                                onClick={(e) => {departmentDropdown.current.click(); setDepartmentId(e.target.value+""); }}
                            >
                            {departments && departments.map(f => (
                                <li
                                    value={f.id}
                                    key={f.id}>
                                {f.name}</li>
                               ))}
                            </Select>
                        </div>

                        <div className={styles["admin-only"]}>  
                            <Checkbox onChange={handleAdminsOnly} checked={state.admins_only} labelText="Viewable by admins only" />
                        </div>

                        { editFolder.type === 'file' && 
                            <div className={styles["admin-only"]}>  
                                <Checkbox onChange={handleRequiresAttest} checked={state.requires_attest} labelText="Requires Attestation" />
                            </div> 
                        }
                    </div>

                    <label>
                        <b>EXPIRATION DATE</b>
                    </label>
                    <DateInput
                        className={styles["date-input"]}
                        value={state["expiration_date"]}
                        onChange={handleChange("expiration_date")}
                        // maxDate={moment().format('YYYY-MM-DD')}
                    />

                    <label>
                        <b>DESCRIPTION / NOTES</b>
                    </label>
                    <textarea
                        onChange={handleChange("description")}
                        rows="5"
                        placeholder="Add some description here"
                        value={state.description}
                    >
                    </textarea>
                </div>
            </div>
            <div className={styles["modal-footer"]}>
                <Button
                    className={styles.button}
                    text="CANCEL"
                    onClick={() => props.setShowModal(false)}
                    color="secondary"
                />
                <Button
                    className={styles.button}
                    text={editFolder ? "UPDATE" : "CREATE"}
                    onClick={createFolder}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = state => ({
    folders: state.FoldersReducer.folders,
    sites: state.SitesReducer.sites,
    departments: state.DepartmentsReducer.departments,
    parentFolder: state.FolderContentsReducer.parentFolder,
});

const mapDispatchToProps = {
    loadFoldersAction,
    loadSitesAction,
    loadDeptAction,
    createFolderAction,
    updateFolderAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateFolderModal);
